export default "__VITE_ASSET__2e6d90b7__"